import { HighlightedRow } from "api/other/models";
import { InvoicePagination } from "components/common/invoicePagination/InvoicePagination";
import { CommonError, RightPanelHandler } from "components/utils";
import { ListDrawerWrapper } from "components/utils/drawer";
import { Loader } from "components/utils/loader";
import { ModuleList } from "components/utils/moduleList";
import { ModuleListBody } from "components/utils/moduleList/components/ModuleListBody";
import { ModuleListHeader } from "components/utils/moduleList/components/ModuleListHeader";
import { manufacturingEmployeesListConfig } from "components/utils/moduleList/utils/moduleListConfig";
import { NoResults } from "components/utils/noResults";
import { useQuery, useToggle } from "hooks";
import { useState } from "react";
import { ListHeader } from "./components/ListHeader";
import { ListItem } from "./components/ListItem";
import { getSearch } from "./utils/getSearch";
import { useManufacturingEmployees } from "api/manufacturingNew/hooks";
import { RouteComponentProps } from "react-router";
import { EmployeesTab as Tab } from "api/manufacturingNew/models";
import { CreateManufacturingEmployeeModal } from "./components/CreateManufacturingEmployeeModal";

export const EmployeesList = ({ match }: RouteComponentProps<{ tab: Tab }>) => {
  const { tab } = match.params;
  const { query } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query, tab });
  const createManufacturingEmployeeModal = useToggle(false);
  const { data: manufacturingEmployees, error, isLoading, pagination } = useManufacturingEmployees(
    search,
  );
  const [highlightedRows] = useState<HighlightedRow[]>([]);

  const noResults = !manufacturingEmployees.length && !isLoading && !error;

  if (error) {
    return (
      <div>
        <ListHeader open={createManufacturingEmployeeModal.open} />
        <div className="mt-4">
          <CommonError status={error._httpStatus_} />
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Loader module="manufacturing" />
        <ListHeader open={createManufacturingEmployeeModal.open} />
      </div>
    );
  }

  return (
    <div className="pageContainer">
      <ListHeader open={createManufacturingEmployeeModal.open} />
      <RightPanelHandler name="manufacturingEmployeesList">
        {({ close, isActive, isHighlighted, togglePanel }) => (
          <ListDrawerWrapper>
            {noResults ? (
              <NoResults on={noResults} subHeader="pracownicy" />
            ) : (
              <ModuleList>
                <ModuleListHeader
                  gridStyle={manufacturingEmployeesListConfig.grid}
                  labels={manufacturingEmployeesListConfig.labels}
                />
                <ModuleListBody>
                  {manufacturingEmployees.map((manufacturingEmployee, index) => (
                    <ListItem
                      highlightedRows={highlightedRows}
                      index={index}
                      isActive={isActive}
                      isHighlighted={isHighlighted}
                      key={manufacturingEmployee.id}
                      manufacturingEmployee={manufacturingEmployee}
                      togglePanel={togglePanel}
                      pageNumber={pagination.page || 0}
                    />
                  ))}
                </ModuleListBody>
              </ModuleList>
            )}
            {/* <RightPanel close={close} /> */}
            <InvoicePagination pagination={pagination} />
          </ListDrawerWrapper>
        )}
      </RightPanelHandler>
      {createManufacturingEmployeeModal.isOpen && (
        <CreateManufacturingEmployeeModal close={createManufacturingEmployeeModal.close} />
      )}
    </div>
  );
};
